import * as Firebase from 'firebase';

export default async function(email: string, password: string) {
  await Firebase.auth().createUserWithEmailAndPassword(email, password);

  await new Promise((resolve, reject) => {
    let unsub: any;

    const handleTimeout = () => {
      if (unsub) {
        unsub();
      }
      reject();
    };

    const timeout = setTimeout(handleTimeout, 5 * 1000);

    unsub = Firebase.auth().onAuthStateChanged(() => {
      clearTimeout(timeout);
      unsub();
      resolve();
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/firebaseSignup.ts